<template>
    <div class="page-restore">
        <div class="block-title">
            Восстановление пароля
            <Loader v-show="pending" class="loader" />
        </div>

        <div v-if="message" class="notification error">
            <IconError class="icon" />
            <div class="text error" v-html="message" />
        </div>

        <div class="form-field">
            <div class="title">Email пользователя</div>
            <div class="value">
                <input id="email"
                       v-model="v.email.$model"
                       :class="{ error: v.email.$error }"
                       autofocus
                       class="email"
                       data-test-id="input-email"
                       placeholder="Введите адрес электронной почты"
                       type="email" />

                <TooltipOld :opened="isLdapEmail" bind-to=".email" class="tooltip inform small ldap" closeable>
                    <div class="container">
                        <IconInform class="icon" />
                        <div class="text">
                            Вы указали почту в домене rt.ru.
                            Восстановление пароля корпоративной учётной записи доступно через службу поддержки
                            <a class="accent" href="https://helpme.rt.ru/tickets/create/sm/3791"
                               target="_blank">Helpme</a>
                        </div>
                    </div>
                </TooltipOld>
            </div>
        </div>

        <div class="form-field form-action">
            <div class="value">
                <button :disabled="v.$invalid || isLdapEmail || pending"
                        class="primary fullwidth action"
                        data-test-id="input-restore"
                        @click="restore">Отправить
                </button>
            </div>
        </div>

        <div class="form-field">
            <div class="value">
                <router-link class="accent" to="/user/login">Вернуться к входу</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { isLdapEmail } from '@/common/allowed.emails.js';
import { emailRulesDefault } from '@/common/util/validations/email.js';
import { restore } from '@/restapi/user/user.js';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

import IconInform from '../icons/inform.svg?component';
import IconError from '@/pages/user/icons/error.svg?component';

export default {
    components: { IconError, IconInform },
    setup() {
        return {
            v: useVuelidate(),
        };
    },
    data() {
        return {
            email: '',
            message: '',

            pending: false,
        };
    },
    computed: {
        isLdapEmail() {
            return isLdapEmail(this.email);
        },
    },
    validations() {
        return {
            email: { required, ...emailRulesDefault() },
        };
    },
    methods: {
        async restore() {
            this.v.$touch();

            if (this.v.$invalid)
                return;

            this.pending = true;

            try {
                await restore({
                    email: this.email,
                });

                this.$router.push('/user/restore/await');

            } catch (e) {
                this.message = e.message;
            } finally {
                this.pending = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.page-restore {
}

.tooltip.ldap .container {
    display: flex;

    .icon {
        flex: none;
        margin-right: 8px;
    }
}
</style>
